module.exports = __webpack_public_path__ + "img/slide2_court.a33aa3e4.png";